"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Utils = require("../../Utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var CloseIcon = function CloseIcon(_ref) {
  var handleClick = _ref.handleClick,
    hidePopup = _ref.hidePopup;
  return /*#__PURE__*/_react.default.createElement("svg", {
    onClick: function onClick() {
      handleClick();
      hidePopup();
    },
    className: "".concat(_Utils.PREFIX_CLASSNAME, "-spectrum-close-icon"),
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "10",
    viewBox: "0 0 10 10"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "icon-close",
    transform: "translate(-7.05 -7.05)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M17.05,8.478,15.622,7.05,12.05,10.622,8.478,7.05,7.05,8.478l3.572,3.572L7.05,15.622,8.478,17.05l3.572-3.572,3.572,3.572,1.428-1.428L13.478,12.05Z",
    fill: "#b1b2b3"
  })));
};
var _default = CloseIcon;
exports.default = _default;